webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(239),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(211)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(247),
  /* scopeId */
  "data-v-a0e9cc44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(204)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(235),
  /* scopeId */
  "data-v-2e2ba9ef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(203)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(234),
  /* scopeId */
  "data-v-2a33e7aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(210)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(246),
  /* scopeId */
  "data-v-97ee29d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(207)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(243),
  /* scopeId */
  "data-v-72df7e66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(212)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(249),
  /* scopeId */
  "data-v-d205692a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(208)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(244),
  /* scopeId */
  "data-v-7cc98933",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(250);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/404',
    name: '404',
    component: __webpack_require__(228)
  }, {
    path: '*',
    redirect: '404'
  }, {
    path: '/',
    name: 'Index',
    component: __webpack_require__(229)
  }, {
    path: '/kobenhavn',
    name: 'Koebenhavn',
    component: __webpack_require__(232),
    meta: { retailerName: 'København' }
  }, {
    path: '/amager',
    name: 'Amager',
    component: __webpack_require__(230),
    meta: { retailerName: 'Amager' }
  }, {
    path: '/gladsaxe',
    name: 'Gladsaxe',
    component: __webpack_require__(231),
    meta: { retailerName: 'Gladsaxe' }
  }]
}));

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(240),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_moment__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise_auto__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sweetalert__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_youtube_embed__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_youtube_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_youtube_embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__deveodk_vue_seo__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__deveodk_vue_seo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__deveodk_vue_seo__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_sweetalert___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_youtube_embed___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__deveodk_vue_seo___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_moment___default.a);
__webpack_require__(4);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return submit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_querystring__);



var namespace = 'https://vw-klub.us16.list-manage.com/subscribe/post-json';

var submit = function submit(body, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(namespace + '?' + __WEBPACK_IMPORTED_MODULE_1_querystring___default.a.stringify(body), null);
};



/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        'layout': __webpack_require__(226)
    }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        intro: {
            type: String,
            required: true
        },
        firstText: {
            type: String,
            required: true
        },
        firstPicture: {
            type: String,
            required: true
        },
        secondText: {
            type: String,
            required: true
        },
        secondPicture: {
            type: String,
            required: true
        },
        thirdText: {
            type: String,
            required: true
        },
        thirdPicture: {
            type: String,
            required: true
        }
    }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        title: {
            type: String,
            required: true
        },
        phone: {
            type: String,
            required: true
        },
        facebookUrl: {
            type: String,
            required: true
        }
    }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        deadline: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            now: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000),
            date: null,
            diff: 0,
            interval: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.date = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(Date.parse(this.deadline.replace(/-/g, '/')) / 1000);
        this.interval = setInterval(function () {
            _this.now = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
        }, 1000);
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.interval);
    },

    computed: {
        seconds: function seconds() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff) % 60;
        },
        minutes: function minutes() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60) % 60;
        },
        hours: function hours() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60 / 60) % 24;
        },
        days: function days() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60 / 60 / 24);
        }
    },
    watch: {
        now: function now(value) {
            this.diff = this.date - this.now;
            if (this.diff <= 0 || this.stop) {
                this.diff = 0;

                clearInterval(this.interval);
            }
        }
    }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        videoId: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            required: true
        },
        bg: {
            type: String,
            required: true
        }
    },
    computed: {
        windowWidth: function windowWidth() {
            return window.innerWidth;
        },
        windowHeight: function windowHeight() {
            return window.innerHeight;
        }
    },
    methods: {
        goToMenuItem: function goToMenuItem(id) {
            this.showMenu = false;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
                scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + id).offset().top
            }, 500);
        }
    }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        title: {
            type: String,
            required: true
        }
    },
    methods: {
        goToMenuItem: function goToMenuItem(id) {
            this.showMenu = false;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
                scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + id).offset().top
            }, 500);
        }
    }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        title: {
            type: String,
            required: true
        },
        staticCarId: {
            type: [Number, String],
            required: true
        },
        buttonText: {
            type: String,
            required: true
        },
        buttonLink: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            windowHeight: 400,
            carId: 0
        };
    },
    created: function created() {
        this.checkHeight();
        this.randomizer();
    },
    mounted: function mounted() {
        this.slideShow();
    },

    methods: {
        slideShow: function slideShow() {
            if (this.staticCarId) {
                this.carId = this.staticCarId;
                return;
            }
            if (!this.carId) {
                this.carId = 1;
            } else if (this.carId === 4) {
                this.carId = 1;
            } else {
                this.carId = this.carId + 1;
            }
        },
        randomizer: function randomizer() {
            var self = this;
            setInterval(function () {
                self.slideShow();
            }, 5000);
        },
        checkHeight: function checkHeight() {
            this.windowHeight = window.innerHeight;
        }
    }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_register_registerService__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        eventId: {
            required: true,
            type: String
        },
        eventToken: {
            required: true,
            type: String
        },
        disabled: {
            required: false,
            type: Boolean
        },
        name: {
            required: true,
            type: String
        }
    },
    data: function data() {
        return {
            windowHeight: 400,
            submitted: false,
            loading: false,
            body: {
                FNAME: '',
                CNAME: '',
                EMAIL: '',
                PHONE: '',
                u: this.eventId,
                id: this.eventToken,
                c: 'JSON.stringify'
            }
        };
    },
    created: function created() {
        this.checkHeight();
    },

    computed: {
        isValidated: function isValidated() {
            var body = this.body;
            if (this.errors.items.length > 0) {
                return false;
            }
            if (body.FNAME === '') {
                return false;
            }
            if (body.CNAME === '') {
                return false;
            }
            if (body.EMAIL === '') {
                return false;
            }
            if (body.PHONE === '') {
                return false;
            }
            return true;
        }
    },
    methods: {
        checkHeight: function checkHeight() {
            this.windowHeight = window.innerHeight;
        },
        register: function register() {
            this.body['b_' + this.eventId + '_' + this.eventToken] = '';
            __WEBPACK_IMPORTED_MODULE_0__services_register_registerService__["a" /* submit */](this.body);
            this.submitted = true;
            window.fbq('trackCustom', 'Succesfuld tilmelding');
            window.fbq('track', 'CompleteRegistration', { content_name: this.name });
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://hooks.slack.com/services/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', {
                username: 'VW ' + this.name,
                text: 'En bruger har lige tilmeldt sig næste netværksmøde!'
            }, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
        },
        newsletterInfo: function newsletterInfo() {
            this.$swal('Fremtidige arrangementer', '3 gange årligt sender vi informationer ud, hvor du kan læse om nye spændende arrangementer.');
        }
    }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        title: {
            type: String,
            require: true
        },
        price: {
            type: String,
            require: true
        },
        mainEmployeeName: {
            type: String,
            require: true
        },
        mainEmployeeImage: {
            type: String,
            require: true
        },
        mainEmployeeTitle: {
            type: String,
            require: true
        },
        secondaryEmployeeName: {
            type: String,
            require: false
        },
        secondaryEmployeeImage: {
            type: String,
            require: false
        },
        secondaryEmployeeTitle: {
            type: String,
            require: false
        },
        thirdEmployeeName: {
            type: String,
            require: false
        },
        thirdEmployeeImage: {
            type: String,
            require: false
        },
        thirdEmployeeTitle: {
            type: String,
            require: false
        },
        fourthEmployeeName: {
            type: String,
            require: false
        },
        fourthEmployeeImage: {
            type: String,
            require: false
        },
        fourthEmployeeTitle: {
            type: String,
            require: false
        },
        fifthEmployeeName: {
            type: String,
            require: false
        },
        fifthEmployeeImage: {
            type: String,
            require: false
        },
        fifthEmployeeTitle: {
            type: String,
            require: false
        }
    }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            year: ''
        };
    },
    mounted: function mounted() {
        this.getYear();
    },

    methods: {
        getYear: function getYear() {
            var year = new Date().getFullYear();
            this.year = year;
        }
    }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {};
    },

    components: {
        'top-menu': __webpack_require__(227),
        'main-footer': __webpack_require__(225)
    },
    methods: {}
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showMenu: false
        };
    },

    methods: {
        toggleMenu: function toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        goToMenuItem: function goToMenuItem(id) {
            this.showMenu = false;
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
                scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + id).offset().top
            }, 500);
        }
    }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Index',
    created: function created() {
        window.fbq('trackCustom', 'Landing');
    },
    data: function data() {
        return {
            loaded: false,
            located: false,
            stores: [{
                name: 'Amager',
                street: 'Englandsvej 437',
                city: '2770 Kastrup',
                link: '/amager',
                lat: 55.613599,
                lng: 12.612724,
                selected: false,
                distance: '',
                active: true,
                show: true
            }, {
                name: 'Gladsaxe',
                street: 'Dynamovej 5',
                city: '2860 Søborg',
                link: '/gladsaxe',
                lat: 55.733158,
                lng: 12.462465,
                selected: false,
                distance: '',
                active: true,
                show: true
            }, {
                name: 'Hillerød',
                street: 'Egespurs Alle 1',
                city: '3400 Hillerød',
                link: '/hilleroed',
                lat: 55.928985,
                lng: 12.263102,
                selected: false,
                distance: '',
                active: false,
                show: false
            }, {
                name: 'København',
                street: 'Banevingen 9',
                city: '2200 København N',
                link: '/kobenhavn',
                lat: 55.706212,
                lng: 12.543432,
                selected: false,
                distance: '',
                active: true,
                show: true
            }, {
                name: 'Køge',
                street: 'Tangmosevej 110',
                city: '4600 Køge',
                link: '/koege',
                lat: 55.475290,
                lng: 12.185744,
                selected: false,
                distance: '',
                active: false,
                show: false
            }, {
                name: 'Odense',
                street: 'Middelfartvej 50',
                city: '5200 Odense V',
                link: '/odense',
                lat: 55.393794,
                lng: 10.356851,
                selected: false,
                distance: '',
                active: false,
                show: true
            }]
        };
    },
    mounted: function mounted() {
        this.getLocation();
    },

    methods: {
        getLocation: function getLocation() {
            var _this = this;

            if (!navigator.geolocation) {
                this.loaded = true;
                return;
            }
            navigator.geolocation.getCurrentPosition(function (position) {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                _this.stores.forEach(function (store) {
                    store.distance = parseInt(_this.calculateDistance(store.lat, store.lng, pos.lat, pos.lng));
                });

                _this.loaded = true;
                _this.located = true;
            }, function () {
                _this.loaded = true;
            });
        },
        calculateDistance: function calculateDistance(lat1, lon1, lat2, lon2) {
            var p = 0.017453292519943295;
            var c = Math.cos;
            var a = 0.5 - c((lat2 - lat1) * p) / 2 + c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p)) / 2;
            var subtotal = 12742 * Math.asin(Math.sqrt(a));

            return subtotal.toFixed(0);
        }
    },
    computed: {
        activeStores: function activeStores() {
            var filtered = this.stores.filter(function (store) {
                return store.show === true;
            });

            return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(filtered, 'distance');
        }
    }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact__);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Amager',
    data: function data() {
        return {
            date: {
                pretty: '12. december 2019',
                formatted: '2019/12/12 11:00'
            }
        };
    },
    created: function created() {
        window.fbq('trackCustom', 'Amager');
    },

    components: {
        'intro': __WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro___default.a,
        'countdown': __WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown___default.a,
        'boxes': __WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes___default.a,
        'practical-info': __WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info___default.a,
        'promo': __WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo___default.a,
        'statement-and-price': __WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price___default.a,
        'registration': __WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration___default.a,
        'contact': __WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact___default.a
    }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact__);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Gladsaxe',
    created: function created() {
        window.fbq('trackCustom', 'Gladsaxe');
    },

    components: {
        'intro': __WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro___default.a,
        'countdown': __WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown___default.a,
        'boxes': __WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes___default.a,
        'practical-info': __WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info___default.a,
        'promo': __WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo___default.a,
        'statement-and-price': __WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price___default.a,
        'registration': __WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration___default.a,
        'contact': __WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact___default.a
    }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact__);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Koebenhavn',
    created: function created() {
        window.fbq('trackCustom', 'Koebenhavn');
    },

    components: {
        'intro': __WEBPACK_IMPORTED_MODULE_0__src_components_home_sections_intro___default.a,
        'countdown': __WEBPACK_IMPORTED_MODULE_1__src_components_home_sections_countdown___default.a,
        'boxes': __WEBPACK_IMPORTED_MODULE_2__src_components_home_sections_boxes___default.a,
        'practical-info': __WEBPACK_IMPORTED_MODULE_3__src_components_home_sections_practical_info___default.a,
        'promo': __WEBPACK_IMPORTED_MODULE_4__src_components_home_sections_promo___default.a,
        'statement-and-price': __WEBPACK_IMPORTED_MODULE_5__src_components_home_sections_statement_and_price___default.a,
        'registration': __WEBPACK_IMPORTED_MODULE_6__src_components_home_sections_registration___default.a,
        'contact': __WEBPACK_IMPORTED_MODULE_7__src_components_home_sections_contact___default.a
    }
});

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 27,
	"./af.js": 27,
	"./ar": 34,
	"./ar-dz": 28,
	"./ar-dz.js": 28,
	"./ar-kw": 29,
	"./ar-kw.js": 29,
	"./ar-ly": 30,
	"./ar-ly.js": 30,
	"./ar-ma": 31,
	"./ar-ma.js": 31,
	"./ar-sa": 32,
	"./ar-sa.js": 32,
	"./ar-tn": 33,
	"./ar-tn.js": 33,
	"./ar.js": 34,
	"./az": 35,
	"./az.js": 35,
	"./be": 36,
	"./be.js": 36,
	"./bg": 37,
	"./bg.js": 37,
	"./bm": 38,
	"./bm.js": 38,
	"./bn": 39,
	"./bn.js": 39,
	"./bo": 40,
	"./bo.js": 40,
	"./br": 41,
	"./br.js": 41,
	"./bs": 42,
	"./bs.js": 42,
	"./ca": 43,
	"./ca.js": 43,
	"./cs": 44,
	"./cs.js": 44,
	"./cv": 45,
	"./cv.js": 45,
	"./cy": 46,
	"./cy.js": 46,
	"./da": 4,
	"./da.js": 4,
	"./de": 49,
	"./de-at": 47,
	"./de-at.js": 47,
	"./de-ch": 48,
	"./de-ch.js": 48,
	"./de.js": 49,
	"./dv": 50,
	"./dv.js": 50,
	"./el": 51,
	"./el.js": 51,
	"./en-au": 52,
	"./en-au.js": 52,
	"./en-ca": 53,
	"./en-ca.js": 53,
	"./en-gb": 54,
	"./en-gb.js": 54,
	"./en-ie": 55,
	"./en-ie.js": 55,
	"./en-nz": 56,
	"./en-nz.js": 56,
	"./eo": 57,
	"./eo.js": 57,
	"./es": 60,
	"./es-do": 58,
	"./es-do.js": 58,
	"./es-us": 59,
	"./es-us.js": 59,
	"./es.js": 60,
	"./et": 61,
	"./et.js": 61,
	"./eu": 62,
	"./eu.js": 62,
	"./fa": 63,
	"./fa.js": 63,
	"./fi": 64,
	"./fi.js": 64,
	"./fo": 65,
	"./fo.js": 65,
	"./fr": 68,
	"./fr-ca": 66,
	"./fr-ca.js": 66,
	"./fr-ch": 67,
	"./fr-ch.js": 67,
	"./fr.js": 68,
	"./fy": 69,
	"./fy.js": 69,
	"./gd": 70,
	"./gd.js": 70,
	"./gl": 71,
	"./gl.js": 71,
	"./gom-latn": 72,
	"./gom-latn.js": 72,
	"./gu": 73,
	"./gu.js": 73,
	"./he": 74,
	"./he.js": 74,
	"./hi": 75,
	"./hi.js": 75,
	"./hr": 76,
	"./hr.js": 76,
	"./hu": 77,
	"./hu.js": 77,
	"./hy-am": 78,
	"./hy-am.js": 78,
	"./id": 79,
	"./id.js": 79,
	"./is": 80,
	"./is.js": 80,
	"./it": 81,
	"./it.js": 81,
	"./ja": 82,
	"./ja.js": 82,
	"./jv": 83,
	"./jv.js": 83,
	"./ka": 84,
	"./ka.js": 84,
	"./kk": 85,
	"./kk.js": 85,
	"./km": 86,
	"./km.js": 86,
	"./kn": 87,
	"./kn.js": 87,
	"./ko": 88,
	"./ko.js": 88,
	"./ky": 89,
	"./ky.js": 89,
	"./lb": 90,
	"./lb.js": 90,
	"./lo": 91,
	"./lo.js": 91,
	"./lt": 92,
	"./lt.js": 92,
	"./lv": 93,
	"./lv.js": 93,
	"./me": 94,
	"./me.js": 94,
	"./mi": 95,
	"./mi.js": 95,
	"./mk": 96,
	"./mk.js": 96,
	"./ml": 97,
	"./ml.js": 97,
	"./mr": 98,
	"./mr.js": 98,
	"./ms": 100,
	"./ms-my": 99,
	"./ms-my.js": 99,
	"./ms.js": 100,
	"./my": 101,
	"./my.js": 101,
	"./nb": 102,
	"./nb.js": 102,
	"./ne": 103,
	"./ne.js": 103,
	"./nl": 105,
	"./nl-be": 104,
	"./nl-be.js": 104,
	"./nl.js": 105,
	"./nn": 106,
	"./nn.js": 106,
	"./pa-in": 107,
	"./pa-in.js": 107,
	"./pl": 108,
	"./pl.js": 108,
	"./pt": 110,
	"./pt-br": 109,
	"./pt-br.js": 109,
	"./pt.js": 110,
	"./ro": 111,
	"./ro.js": 111,
	"./ru": 112,
	"./ru.js": 112,
	"./sd": 113,
	"./sd.js": 113,
	"./se": 114,
	"./se.js": 114,
	"./si": 115,
	"./si.js": 115,
	"./sk": 116,
	"./sk.js": 116,
	"./sl": 117,
	"./sl.js": 117,
	"./sq": 118,
	"./sq.js": 118,
	"./sr": 120,
	"./sr-cyrl": 119,
	"./sr-cyrl.js": 119,
	"./sr.js": 120,
	"./ss": 121,
	"./ss.js": 121,
	"./sv": 122,
	"./sv.js": 122,
	"./sw": 123,
	"./sw.js": 123,
	"./ta": 124,
	"./ta.js": 124,
	"./te": 125,
	"./te.js": 125,
	"./tet": 126,
	"./tet.js": 126,
	"./th": 127,
	"./th.js": 127,
	"./tl-ph": 128,
	"./tl-ph.js": 128,
	"./tlh": 129,
	"./tlh.js": 129,
	"./tr": 130,
	"./tr.js": 130,
	"./tzl": 131,
	"./tzl.js": 131,
	"./tzm": 133,
	"./tzm-latn": 132,
	"./tzm-latn.js": 132,
	"./tzm.js": 133,
	"./uk": 134,
	"./uk.js": 134,
	"./ur": 135,
	"./ur.js": 135,
	"./uz": 137,
	"./uz-latn": 136,
	"./uz-latn.js": 136,
	"./uz.js": 137,
	"./vi": 138,
	"./vi.js": 138,
	"./x-pseudo": 139,
	"./x-pseudo.js": 139,
	"./yo": 140,
	"./yo.js": 140,
	"./zh-cn": 141,
	"./zh-cn.js": 141,
	"./zh-hk": 142,
	"./zh-hk.js": 142,
	"./zh-tw": 143,
	"./zh-tw.js": 143
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(242),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(233),
  /* scopeId */
  "data-v-1e6fb320",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(206)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(237),
  /* scopeId */
  "data-v-30b40666",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(205)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(236),
  /* scopeId */
  "data-v-301a1469",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(209)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(245),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(241),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(248),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(238),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('top-menu'), _vm._v(" "), _c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "main-content"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-cover bg-overlay-black-6 height-100 no-padding width-100",
    style: ('height:' + _vm.windowHeight + 'px!important;background:url(' + _vm.bg + ');background-size:cover;'),
    attrs: {
      "id": "home-bg-video"
    }
  }, [(_vm.videoId) ? _c('div', {
    staticClass: "bgvideo",
    staticStyle: {
      "margin-left": "-80px"
    }
  }, [_c('youtube', {
    attrs: {
      "video-id": _vm.videoId,
      "player-vars": {
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        disablekb: 1,
        loop: 1,
        playlist: _vm.videoId,
        fadeOnStartTime: 500
      },
      "player-width": _vm.windowWidth + 160,
      "player-height": _vm.windowHeight + 90,
      "mute": true
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "display-table height-100 position-absolute position-top position-left width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1 text-center"
  }, [_c('h2', {
    staticClass: "vw-bold display-block font-family-alt font-weight-700 letter-spacing-2 text-uppercase text-white xs-title-extra-large sm-title-extra-large-3 title-extra-large-5"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_c('p', {
    staticClass: "vw-bold font-family-alt letter-spacing-1 margin-3 no-margin-bottom no-margin-rl text-gray-light xs-text-large text-extra-large text-uppercase"
  }, [_vm._t("subtitle")], 2)]), _vm._v(" "), _c('a', {
    staticClass: "page-scroll btn btn-base-color sm-btn-medium btn-large margin-4-5 no-margin-bottom no-margin-rl",
    on: {
      "click": function($event) {
        _vm.goToMenuItem('register')
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.buttonText) + "\n                            ")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-white",
    attrs: {
      "id": "countdown"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_c('div', {
    staticClass: "countdown bg-white border border-gray-light border-round sm-no-padding-rl no-padding-rl sm-padding-5 padding-2-5 position-relative"
  }, [_c('div', {
    staticClass: "no-padding-tb padding-3-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 sm-margin-4 sm-no-margin-bottom sm-no-margin-rl",
    attrs: {
      "data-mh": "mh-col-countdown"
    }
  }, [_c('div', {
    staticClass: "clock",
    attrs: {
      "data-until-date": "1516167000"
    }
  }, [_c('div', {
    staticClass: "clock-item"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block xs-text-extra-large title-medium"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.days) + "\n                                                ")]), _vm._v(" "), _c('span', {
    staticClass: "display-block text-small"
  }, [_vm._v("dage")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clock-item"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block xs-text-extra-large title-medium"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.hours) + "\n                                                ")]), _vm._v(" "), _c('span', {
    staticClass: "display-block text-small"
  }, [_vm._v("timer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clock-item"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block xs-text-extra-large title-medium"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.minutes) + "\n                                                ")]), _vm._v(" "), _c('span', {
    staticClass: "display-block text-small"
  }, [_vm._v("min.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clock-item"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block xs-text-extra-large title-medium"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.seconds) + "\n                                                ")]), _vm._v(" "), _c('span', {
    staticClass: "display-block text-small"
  }, [_vm._v("sek.")])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 countdown-text",
    attrs: {
      "data-mh": "mh-col-countdown"
    }
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle sm-text-center"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 xs-text-extra-large title-medium text-uppercase"
  }, [_vm._v("Sæt kryds i kalenderen")]), _vm._v(" "), _c('span', {
    staticClass: "display-block font-family-alt margin-1 no-margin-bottom no-margin-rl text-large text-gray-dark"
  }, [_vm._v("Netværksmødet afholdes om:")])])])])
}]}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page-wrapper"
  }, [_c('div', {
    staticClass: "error-page-inner"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('h3', [_vm._v("Ups! Der er sket en fejl ...")]), _vm._v(" "), _c('p', [_vm._v("Vi ved ikke helt hvad der er sket, men vi kan desværre ikke vise denne side. Dette kan være fordi du har forsøgt at tilgå et dødt link eller fordi du ikke har adgang til denne side.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: _vm.$route.name
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Genindlæs siden\n            ")])]), _vm._v("\n        |\n        "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Gå til forsiden\n            ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-fixed-top navbar-white shrink",
    attrs: {
      "id": "navigation"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "navbar-header col-md-4"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand page-scroll font-family-alt letter-spacing-1 text-extra-large text-uppercase",
    on: {
      "click": function($event) {
        _vm.goToMenuItem('home-bg-video')
      }
    }
  }, [_c('div', [_vm._v("\n                        VW ERHVERVSKLUB\n                        "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n                            " + _vm._s(this.$route.meta.retailerName) + "\n                        ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "navbar-collapse collapse in col-md-8 pull-right",
    attrs: {
      "id": "navbar-deveo"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav font-family-alt letter-spacing-1 text-small text-uppercase"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToMenuItem('about')
      }
    }
  }, [_vm._v("Praktiske informationer")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToMenuItem('venue')
      }
    }
  }, [_vm._v("Få inspiration")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToMenuItem('ticket')
      }
    }
  }, [_vm._v("Pris")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToMenuItem('register')
      }
    }
  }, [_vm._v("Tilmelding")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goToMenuItem('contact')
      }
    }
  }, [_vm._v("Kontakt")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "seo"
  }, [_c('seo-title', {
    attrs: {
      "content": "Volkswagen Klub København - Din volkswagen familie"
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter København og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-keywords', {
    attrs: {
      "content": "VW, VW København, VW Erhvervscenter, VW Erhvervsbiler, Volkswagen"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": "Volkswagen Klubbens netværksmøde - Skal du med?"
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter København og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-og-site-name', {
    attrs: {
      "content": "VW København Erhvervscenter"
    }
  }), _vm._v(" "), _c('seo-google-name', {
    attrs: {
      "content": "Volkswagen Klubbens netværksmøde - Skal du med?"
    }
  }), _vm._v(" "), _c('seo-google-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter København og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-google-image', {
    attrs: {
      "content": ""
    }
  })], 1), _vm._v(" "), _c('intro', {
    attrs: {
      "videoId": "7bGJbhDr7TM",
      "bg": "/static/images/focus-1.jpg",
      "buttonText": "DATO KOMMER SNART"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            VOLKSWAGEN KØBENHAVN"), _c('br'), _vm._v("ERHVERVSKLUB\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "subtitle"
    },
    slot: "subtitle"
  }, [_vm._v("\n            Deltag i Volkswagen ErhvervsCenter Københavns netværksmøde og udvid dit netværk på en uformel måde.\n        ")])]), _vm._v(" "), _c('boxes', {
    attrs: {
      "intro": "Volkswagen ErhvervsCenter Københavns netværksmøde",
      "firstText": "God stemning & nye bekendtskaber",
      "firstPicture": "/static/images/focus-1.jpg",
      "secondText": "Minvolkswagen: Din vej til flådestyring",
      "secondPicture": "/static/images/focus-2.jpg",
      "thirdText": "Innovativ bilindretning",
      "thirdPicture": "/static/images/focus-3.jpg"
    }
  }), _vm._v(" "), _c('practical-info', {
    attrs: {
      "title": "Dette skal du glæde dig til"
    }
  }, [_c('div', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n            For at give vores kunder ny inspiration og et forum for networking, holder vi for danske håndværkere jævnligt netværksmøder. Her er der mulighed for deltagerne, vores oplægsholdere og os at indgå i tæt dialog og videndele om udfordringer, ny teknologi og de muligheder, der byder sig i fremtiden.\n            "), _c('br'), _c('br'), _vm._v("\n            Hvert møde har et fagligt fokus, hvor vi får besøg af en ekspert på området. Det kan være finansiering, forsikring, håndværktøj, revision, markedsføring og mange flere. Hold øje med, hvad du kan opleve ved det møde, du ønsker at deltage i.\n            "), _c('br'), _c('br'), _vm._v("\n            Vi starter tidligt om morgenen, så det ikke går ud over din arbejdstid. Der serveres morgenmad og en velsmagende kop friskbrygget kaffe. Vi glæder os til at se dig.\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "address"
    },
    slot: "address"
  }, [_vm._v("\n            Volkswagen København"), _c('br'), _vm._v("\n            Banevingen 9"), _c('br'), _vm._v("\n            2200 København N\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "datetime"
    },
    slot: "datetime"
  }, [_vm._v("\n            Dato kommer snart\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "partners"
    },
    slot: "partners"
  }, [_c('a', {
    attrs: {
      "href": "https://deveo.dk/",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/deveo-logo.png",
      "width": "120"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "vw-bold"
    }
  }, [_vm._v("Volkswagen")]), _vm._v(" Finans\n            ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "vw-bold"
    }
  }, [_vm._v("Volkswagen")]), _vm._v(" Forsikring\n            ")])])]), _vm._v(" "), _c('promo', {
    attrs: {
      "title": "Transporter",
      "staticCarId": "1",
      "buttonLink": "https://www.volkswagen-erhvervsbiler.dk/da/modeller/transporter-kassevogn.html#",
      "buttonText": "Online showroom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n            Transporter med sikkerheds- eller infotainmentpakke uden merpris.\n        ")])]), _vm._v(" "), _c('statement-and-price', {
    attrs: {
      "title": "Gå herfra inspireret og med nye bekendtskaber",
      "price": "GRATIS",
      "mainEmployeeImage": "/static/images/mg.jpg",
      "mainEmployeeName": "Martin Gill",
      "mainEmployeeTitle": "Salgschef, Volkswagen ErhvervsCenter København",
      "secondaryEmployeeImage": "/static/images/rv.jpg",
      "secondaryEmployeeName": "Runi Villebæk",
      "secondaryEmployeeTitle": "Salgsrådgiver, Volkswagen ErhvervsCenter København"
    }
  }, [_c('div', {
    attrs: {
      "slot": "statement"
    },
    slot: "statement"
  }, [_vm._v("\n            Deltag i vores uformelle netværksmøde, hvor du både bliver inspireret af nye løsninger indenfor teknologi, leasing og meget mere, samtidig med at vi sammen kan løse de problemstillinger du måtte have i din dagligdag.\n            "), _c('br'), _c('br'), _vm._v("\n            Bilverdenen er i konstant forandring og i årene fremover vil der derfor blive stillet større krav til driftsomkostningerne/TCO af virksomhedens flåde. Du vil få større budgetsikkerhed samt højne kvaliteten af din investering.\n            "), _c('br'), _c('br'), _vm._v("\n            Om din flåde består af 1 eller 100 biler, står vi altid klar med professionel rådgivning.\n            "), _c('br'), _c('br'), _vm._v("\n            Vi glæder os til at byde dig velkommen i Volkswagen familien.\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Adgang til arrangement")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Mad & drikke")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Networking")])]), _vm._v(" "), _c('registration', {
    attrs: {
      "eventId": "ddb054affa69ce60f11597144",
      "eventToken": "4243223ffc",
      "disabled": true,
      "name": "Koebenhavn"
    }
  }), _vm._v(" "), _c('contact', {
    attrs: {
      "title": "Volkswagen ErhvervsCenter København",
      "phone": "+45 43 22 30 12",
      "facebookUrl": "VolkswagenCopenhagen"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-white overflow-hidden position-relative width-100",
    attrs: {
      "id": "intro"
    }
  }, [_c('div', {
    staticClass: "container-fluid no-padding"
  }, [_c('div', {
    staticClass: "row no-padding-rl xs-padding-6 padding-4"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-1 text-gray-dark-2 text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.intro))]), _vm._v(" "), _c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-2 margin-1 no-margin-bottom text-gray-dark-2 text-uppercase xs-text-extra-large title-large"
  }, [_vm._v("Du kommer til at opleve:")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "features-box col-md-4 no-padding text-center"
  }, [_c('div', {
    staticClass: "bg-cover bg-overlay-black-4 overflow-hidden position-relative",
    style: ('background-image: url(' + _vm.firstPicture + ')')
  }, [_c('div', {
    staticClass: "height-100 position-absolute position-top position-left width-100"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell text-center vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-2 text-medium text-uppercase text-white"
  }, [_vm._v(_vm._s(_vm.firstText))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "features-box col-md-4 no-padding text-center"
  }, [_c('div', {
    staticClass: "bg-cover bg-overlay-black-4 overflow-hidden position-relative",
    style: ('background-image: url(' + _vm.secondPicture + ')')
  }, [_c('div', {
    staticClass: "height-100 position-absolute position-top position-left width-100"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell text-center vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-2 text-medium text-uppercase text-white"
  }, [_vm._v(_vm._s(_vm.secondText))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "features-box col-md-4 no-padding text-center"
  }, [_c('div', {
    staticClass: "bg-cover bg-overlay-black-4 overflow-hidden position-relative",
    style: ('background-image: url(' + _vm.thirdPicture + ')')
  }, [_c('div', {
    staticClass: "height-100 position-absolute position-top position-left width-100"
  }, [_c('div', {
    staticClass: "display-table height-100 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell text-center vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-2 text-medium text-uppercase text-white"
  }, [_vm._v(_vm._s(_vm.thirdText))])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(this.$route.name === 'Index') ? _c('router-view') : _c('layout')], 1)
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "seo"
  }, [_c('seo-title', {
    attrs: {
      "content": 'Netværksmøde d. ' + _vm.date.pretty + ' hos VW Amager - Skal du med?'
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter Amager og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-keywords', {
    attrs: {
      "content": "VW, VW Amager, VW Erhvervscenter, VW Erhvervsbiler, Volkswagen"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": 'Netværksmøde d. ' + _vm.date.pretty + ' hos VW Amager - Skal du med?'
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter Amager og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-og-site-name', {
    attrs: {
      "content": "VW Amager Erhvervscenter"
    }
  }), _vm._v(" "), _c('seo-google-name', {
    attrs: {
      "content": 'Netværksmøde d. ' + _vm.date.pretty + ' hos VW Amager - Skal du med?'
    }
  }), _vm._v(" "), _c('seo-google-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter Amager og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-google-image', {
    attrs: {
      "content": ""
    }
  })], 1), _vm._v(" "), _c('intro', {
    attrs: {
      "buttonText": _vm.date.pretty + ' - Tilmeld dig her',
      "bg": "/static/images/focus-1.jpg",
      "videoId": "7bGJbhDr7TM"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            VOLKSWAGEN AMAGER"), _c('br'), _vm._v("ERHVERVSKLUB\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "subtitle"
    },
    slot: "subtitle"
  }, [_vm._v("\n            Deltag i Volkswagen ErhvervsCenter Amagers netværksmøde og udvid dit netværk på en uformel måde.\n        ")])]), _vm._v(" "), _c('countdown', {
    attrs: {
      "deadline": _vm.date.formatted
    }
  }), _vm._v(" "), _c('boxes', {
    attrs: {
      "intro": "Volkswagen ErhvervsCenter Amagers netværksmøde",
      "firstText": "God stemning & nye bekendtskaber",
      "firstPicture": "/static/images/focus-1.jpg",
      "secondText": "Minvolkswagen: Din vej til flådestyring",
      "secondPicture": "/static/images/focus-2.jpg",
      "thirdText": "Innovativ bilindretning",
      "thirdPicture": "/static/images/focus-3.jpg"
    }
  }), _vm._v(" "), _c('practical-info', {
    attrs: {
      "title": "Dette skal du glæde dig til"
    }
  }, [_c('div', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n            For at give vores kunder ny inspiration og et forum for networking, holder vi for danske håndværkere jævnligt netværksmøder. Her er der mulighed for deltagerne, vores oplægsholdere og os at indgå i tæt dialog og videndele om udfordringer, ny teknologi og de muligheder, der byder sig i fremtiden.\n            "), _c('br'), _c('br'), _vm._v("\n            Hvert møde har et fagligt fokus, hvor vi får besøg af en ekspert på området. Det kan være finansiering, forsikring, håndværktøj, revision, markedsføring og mange flere. Hold øje med, hvad du kan opleve ved det møde, du ønsker at deltage i.\n            ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "address"
    },
    slot: "address"
  }, [_vm._v("\n            Volkswagen Amager"), _c('br'), _vm._v("\n            Englandsvej 437"), _c('br'), _vm._v("\n            2770 Kastrup\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "datetime"
    },
    slot: "datetime"
  }, [_vm._v("\n            Torsdag"), _c('br'), _vm._v("\n            " + _vm._s(_vm.date.pretty)), _c('br'), _vm._v("\n            Kl. 11.00 - 14.00\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "partners"
    },
    slot: "partners"
  }, [_c('a', {
    attrs: {
      "href": "https://www.ducatidanmark.dk",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ducati.png",
      "width": "60"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.anmeld-haandvaerker.dk/",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/anmeld_haandvaerker.png",
      "width": "120"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.sortimo.dk/",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/Sortimo.png",
      "width": "120"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://deveo.dk/",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/deveo-logo.png",
      "width": "120"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.if.dk",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/if.png",
      "width": "60"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "15px",
      "white-space": "nowrap"
    },
    attrs: {
      "href": "https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "vw-bold"
    }
  }, [_vm._v("Volkswagen")]), _vm._v(" Finans\n            ")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "white-space": "nowrap"
    },
    attrs: {
      "href": "https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "vw-bold"
    }
  }, [_vm._v("Volkswagen")]), _vm._v(" Forsikring\n            ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://smartvan.dk/",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "src": "/static/images/smartvan.png",
      "width": "200"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.soeger.dk/",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "src": "/static/images/soeger.png",
      "width": "150"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.rtt.dk/",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": "/static/images/rtt.png",
      "width": "80"
    }
  })])])]), _vm._v(" "), _c('promo', {
    attrs: {
      "title": "Transporter",
      "staticCarId": "1",
      "buttonLink": "https://www.volkswagen-erhvervsbiler.dk/da/modeller/transporter-kassevogn.html#",
      "buttonText": "Online showroom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n            Transporter med sikkerheds- eller infotainmentpakke uden merpris.\n        ")])]), _vm._v(" "), _c('statement-and-price', {
    attrs: {
      "title": "Gå herfra inspireret og med nye bekendtskaber",
      "price": "GRATIS",
      "mainEmployeeImage": "/static/images/nk.jpg",
      "mainEmployeeName": "Nigel Kelly",
      "mainEmployeeTitle": "Salgschef",
      "secondaryEmployeeImage": "/static/images/na.jpg",
      "secondaryEmployeeName": "Nick Andreasen",
      "secondaryEmployeeTitle": "Salgsrådgiver Erhverv",
      "thirdEmployeeImage": "/static/images/fk.jpg",
      "thirdEmployeeName": "Frank Kalman",
      "thirdEmployeeTitle": "Servicerådgiver Erhverv"
    }
  }, [_c('div', {
    attrs: {
      "slot": "statement"
    },
    slot: "statement"
  }, [_vm._v("\n            Deltag i vores uformelle netværksmøde, hvor du både bliver inspireret af nye løsninger indenfor teknologi, leasing og meget mere, samtidig med at vi sammen kan løse de problemstillinger du måtte have i din dagligdag.\n            "), _c('br'), _c('br'), _vm._v("\n            Bilverdenen er i konstant forandring og i årene fremover vil der derfor blive stillet større krav til driftsomkostningerne/TCO af virksomhedens flåde. Du vil få større budgetsikkerhed samt højne kvaliteten af din investering.\n            "), _c('br'), _c('br'), _vm._v("\n            Om din flåde består af 1 eller 100 biler, står vi altid klar med professionel rådgivning.\n            "), _c('br'), _c('br'), _vm._v("\n            Vi glæder os til at byde dig velkommen i Volkswagen familien.\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Adgang til arrangement")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Mad & drikke")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Networking")])]), _vm._v(" "), _c('registration', {
    attrs: {
      "eventId": "ddb054affa69ce60f11597144",
      "eventToken": "6e2fa0494e",
      "name": "Amager"
    }
  }), _vm._v(" "), _c('contact', {
    attrs: {
      "title": "Volkswagen Amager ErhvervsCenter",
      "phone": "+45 32 47 90 00",
      "facebookUrl": "vwamager"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    staticClass: "footer bg-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "footer-copyright text-center border-top border-gray-light"
  }, [_c('span', {
    staticClass: "font-family-alt letter-spacing-1 text-gray-dark text-small text-uppercase"
  }, [_vm._v("\n                            " + _vm._s(_vm.year) + " © Volkswagen ErhvervsCenter " + _vm._s(this.$route.meta.retailerName) + ". Udviklet af "), _vm._m(0, false, false), _vm._v(".\n                        ")])])])])])]), _vm._v(" "), _vm._m(1, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "href": "https://deveo.dk"
    }
  }, [_c('u', [_vm._v("Deveo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "page-scroll scroll-to-top",
    attrs: {
      "href": "#page-top"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })])
}]}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-cover bg-overlay-black-5 display-table height-100 no-padding width-100",
    class: {
      'transporter': _vm.carId == 1, 'caddy': _vm.carId == 2, 'crafter': _vm.carId == 3, 'amarok': _vm.carId == 4
    },
    style: ('height:' + _vm.windowHeight + 'px!important'),
    attrs: {
      "id": "venue"
    }
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-md-offset-7"
  }, [_c('div', {
    staticClass: "mb-outer bg-white border-round padding-13 position-relative"
  }, [_c('div', {
    staticClass: "mb-inner"
  }, [_c('h3', {
    staticClass: "font-family-alt font-weight-700 letter-spacing-2 text-uppercase xs-title-small title-medium title-sideline-base-color vw-bold"
  }, [_vm._v("Bliv inspireret")]), _vm._v(" "), _c('p', {
    staticClass: "margin-4-5 no-margin-bottom no-margin-rl text-large text-gray-dark-2 vw-body"
  }, [_vm._t("text")], 2), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-black btn-medium margin-7 no-margin-bottom no-margin-rl",
    attrs: {
      "rel": "noopener",
      "target": "_blank",
      "href": _vm.buttonLink
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-white-3",
    attrs: {
      "id": "ticket"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-7"
  }, [_c('h2', {
    staticClass: "font-family-alt sm-title-large title-extra-large-2 text-gray-dark-2 vw-bold"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "bg-base-color margin-6-5 no-margin-bottom no-margin-rl separator-line-extra-thick-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial margin-6 no-margin-bottom no-margin-rl"
  }, [_c('div', {
    staticClass: "bg-white border border-gray-light border-round padding-5 width-100"
  }, [_c('p', {
    staticClass: "no-margin text-gray-dark- text-large"
  }, [_vm._t("statement")], 2)]), _vm._v(" "), (_vm.mainEmployeeName) ? _c('div', {
    staticClass: "col-md-6 testimonial-avatar position-relative"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "1000px"
    },
    attrs: {
      "src": _vm.mainEmployeeImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-avatar-label"
  }, [_c('div', {
    staticClass: "display-table height-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.mainEmployeeName))]), _vm._v(" "), _c('span', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2"
  }, [_vm._v(_vm._s(_vm.mainEmployeeTitle))])])])])]) : _vm._e(), _vm._v(" "), (_vm.secondaryEmployeeName) ? _c('div', {
    staticClass: "col-md-6 testimonial-avatar position-relative"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "1000px"
    },
    attrs: {
      "src": _vm.secondaryEmployeeImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-avatar-label"
  }, [_c('div', {
    staticClass: "display-table height-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.secondaryEmployeeName))]), _vm._v(" "), _c('span', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2"
  }, [_vm._v(_vm._s(_vm.secondaryEmployeeTitle))])])])])]) : _vm._e(), _vm._v(" "), (_vm.thirdEmployeeName) ? _c('div', {
    staticClass: "col-md-6 testimonial-avatar position-relative"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "1000px"
    },
    attrs: {
      "src": _vm.thirdEmployeeImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-avatar-label"
  }, [_c('div', {
    staticClass: "display-table height-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.thirdEmployeeName))]), _vm._v(" "), _c('span', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2"
  }, [_vm._v(_vm._s(_vm.thirdEmployeeTitle))])])])])]) : _vm._e(), _vm._v(" "), (_vm.fourthEmployeeName) ? _c('div', {
    staticClass: "col-md-6 testimonial-avatar position-relative"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "1000px"
    },
    attrs: {
      "src": _vm.fourthEmployeeImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-avatar-label"
  }, [_c('div', {
    staticClass: "display-table height-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.fourthEmployeeName))]), _vm._v(" "), _c('span', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2"
  }, [_vm._v(_vm._s(_vm.fourthEmployeeTitle))])])])])]) : _vm._e(), _vm._v(" "), (_vm.fifthEmployeeName) ? _c('div', {
    staticClass: "col-md-6 testimonial-avatar position-relative"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "1000px"
    },
    attrs: {
      "src": _vm.fifthEmployeeImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "testimonial-avatar-label"
  }, [_c('div', {
    staticClass: "display-table height-100"
  }, [_c('div', {
    staticClass: "display-table-cell vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 no-margin-bottom no-margin-rl text-medium text-uppercase"
  }, [_vm._v(_vm._s(_vm.fifthEmployeeName))]), _vm._v(" "), _c('span', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-medium text-gray-dark-2"
  }, [_vm._v(_vm._s(_vm.fifthEmployeeTitle))])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 col-md-offset-1 xs-margin-8 xs-no-margin-bottom xs-no-margin-rl"
  }, [_c('div', {
    staticClass: "pricing bg-white border border-gray-light border-round box-shadow-yes ease position-relative"
  }, [_c('div', {
    staticClass: "display-table height-100 no-padding-tb padding-13 width-100"
  }, [_c('div', {
    staticClass: "display-table-cell no-padding-rl padding-18 text-center vertical-align-middle"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-1 text-gray-dark-2 text-large text-uppercase"
  }, [_vm._v("PRIS FOR DELTAGELSE")]), _vm._v(" "), _c('span', {
    staticClass: "vw-bold display-block font-family-alt margin-11 no-letter-spacing no-margin-bottom no-margin-rl text-gray-dark-2 title-extra-large-4"
  }, [_vm._v("\n                                " + _vm._s(_vm.price) + "\n                                ")]), _vm._v(" "), _c('span', {
    staticClass: "bg-gray-light-2 margin-10-5 no-margin-bottom no-margin-rl separator-line-full"
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled margin-11 no-margin-bottom no-margin-rl text-gray-dark2 text-large text-left"
  }, [_vm._t("benefits")], 2), _vm._v(" "), _c('p', {
    staticClass: "margin-11 no-margin-bottom no-margin-rl text-gray-dark-2 text-medium"
  }, [_vm._v("Tilmelding skal ske senest 10 dage før arrangementets start, da mad & drikke bestilles forinden.")])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mainpage"
  }, [_c('div', {
    staticClass: "seo"
  }, [_c('seo-title', {
    attrs: {
      "content": "Volkswagen Erhvervsklub - Din Volkswagen familie"
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen Erhvervsklub og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-keywords', {
    attrs: {
      "content": "VW, VW Erhvervscenter, VW Erhvervsbiler, VW Erhvervsklub, Volkswagen"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": "Volkswagen Erhvervsklub - Din Volkswagen familie"
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen Erhvervsklub og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-google-name', {
    attrs: {
      "content": "Volkswagen Erhvervsklub - Din Volkswagen familie"
    }
  }), _vm._v(" "), _c('seo-google-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen Erhvervsklub og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-google-image', {
    attrs: {
      "content": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('p', {
    staticClass: "custom-body"
  }, [_vm._v("\n            Vælg din foretrukne forhandler\n        ")]), _vm._v(" "), (!_vm.loaded) ? _c('div', {
    staticClass: "loader",
    staticStyle: {
      "margin": "10px 0 20px 0",
      "opacity": "0.75",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    staticStyle: {
      "font-size": "48px",
      "color": "#0099da"
    }
  }), _c('br'), _vm._v("\n            Finder din nærmeste forhandler\n        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list-group",
    class: {
      'location': _vm.located
    }
  }, _vm._l((_vm.activeStores), function(store) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-2"
    }, [_c('img', {
      attrs: {
        "src": "static/images/vw-logo.png"
      }
    }), _vm._v(" "), (store.distance !== '') ? _c('sup', [_vm._v(_vm._s(store.distance) + "km")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-10 col-md-10 col-sm-10 col-xs-10"
    }, [_vm._v("\n                        " + _vm._s(store.name) + "\n                        "), _c('span', [_vm._v("\n                            " + _vm._s(store.street)), _c('br'), _vm._v("\n                            " + _vm._s(store.city) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "chooser"
    }, [(store.active) ? _c('a', {
      attrs: {
        "href": store.link
      }
    }, [_c('span', [_vm._v("Vælg")])]) : _c('i', [_vm._v("Kommer"), _c('br'), _vm._v("snart")])]), _vm._v(" "), _vm._m(1, true, false)])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-6 col-sm-6"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "custom-header"
  }, [_c('span', [_vm._v("Volkswagen")]), _vm._v("\n            Erhvervsklub\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "closest"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Baseret på din lokation\n                        ")])
}]}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-white-2",
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 xs-text-center"
  }, [_c('p', {
    staticClass: "vw-bold font-family-alt text-extra-large"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "margin-5-5 no-margin-bottom no-margin-rl text-large text-gray-dark-2"
  }, [_vm._t("text")], 2), _vm._v(" "), _c('a', {
    staticClass: "page-scroll btn btn-outline-black btn-medium margin-6-5 no-margin-bottom no-margin-rl",
    on: {
      "click": function($event) {
        _vm.goToMenuItem('register')
      }
    }
  }, [_vm._v("\n                    Tilmeld dig nu\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 xs-margin-10 sm-margin-5 xs-no-margin-bottom sm-no-margin-bottom xs-no-margin-rl sm-no-margin-rl xs-text-center"
  }, [_c('i', {
    staticClass: "fa fa-map-marker display-block text-base-color title-extra-large-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 margin-5 no-margin-bottom no-margin-rl text-large text-uppercase vw-bold"
  }, [_vm._v("Adresse")]), _vm._v(" "), _c('p', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-large text-gray-dark-2"
  }, [_vm._t("address")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 xs-margin-10 sm-margin-5 xs-no-margin-bottom sm-no-margin-bottom xs-no-margin-rl sm-no-margin-rl xs-text-center"
  }, [_c('i', {
    staticClass: "fa fa-clock-o display-block text-base-color title-extra-large-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 margin-5 no-margin-bottom no-margin-rl text-large text-uppercase vw-bold"
  }, [_vm._v("Dato & tid")]), _vm._v(" "), _c('p', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-large text-gray-dark-2"
  }, [_vm._t("datetime")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 sm-margin-5 sm-no-margin-bottom sm-no-margin-rl xs-text-center"
  }, [_c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-handshake-o display-block text-base-color title-extra-large-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 margin-5 no-margin-bottom no-margin-rl text-large text-uppercase vw-bold"
  }, [_vm._v("Partnere")]), _vm._v(" "), _c('p', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-large text-gray-dark-2 partners"
  }, [_vm._t("partners")], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row no-padding-rl no-padding-top padding-8"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [_c('h3', {
    staticClass: "font-family-alt font-weight-700 letter-spacing-2 text-uppercase xs-title-small title-medium title-sideline-base-color"
  }, [_vm._v("Praktiske informationer")])])])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-white",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 text-center"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "margin-5 no-margin-bottom no-margin-rl"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-phone display-block text-base-color xs-title-large title-extra-large-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "display-block margin-5 no-margin-bottom no-margin-rl text-gray-dark-2 xs-text-large title-small mb50"
  }, [_vm._v(_vm._s(_vm.phone))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('div', {
    staticClass: "fb-page",
    attrs: {
      "data-href": 'https://www.facebook.com/' + _vm.facebookUrl,
      "data-tabs": "timeline",
      "data-small-header": "false",
      "data-adapt-container-width": "true",
      "data-hide-cover": "false",
      "data-show-facepile": "false"
    }
  }, [_c('blockquote', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "cite": 'https://www.facebook.com/' + _vm.facebookUrl
    }
  }, [_c('a', {
    attrs: {
      "href": 'https://www.facebook.com/' + _vm.facebookUrl
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.title) + "\n                        ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "display-block font-weight-300 letter-spacing-1 title-large"
  }, [_c('b', [_vm._v("Har du spørgsmål?")]), _c('br'), _vm._v("Kontakt vores erhvervscenter:")])
}]}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "seo"
  }, [_c('seo-title', {
    attrs: {
      "content": "Volkswagen Klub Gladsaxe - Din volkswagen familie"
    }
  }), _vm._v(" "), _c('seo-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter Gladsaxe og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-author', {
    attrs: {
      "content": "Deveo ApS"
    }
  }), _vm._v(" "), _c('seo-keywords', {
    attrs: {
      "content": "VW, VW Gladsaxe, VW Erhvervscenter, VW Erhvervsbiler, Volkswagen"
    }
  }), _vm._v(" "), _c('seo-og-title', {
    attrs: {
      "content": "Volkswagen Klubbens netværksmøde - Skal du med?"
    }
  }), _vm._v(" "), _c('seo-og-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter Gladsaxe og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-og-site-name', {
    attrs: {
      "content": "VW Gladsaxe Erhvervscenter"
    }
  }), _vm._v(" "), _c('seo-google-name', {
    attrs: {
      "content": "Volkswagen Klubbens netværksmøde - Skal du med?"
    }
  }), _vm._v(" "), _c('seo-google-description', {
    attrs: {
      "content": "Kom til netværksmøde ved Volkswagen ErhvervsCenter Gladsaxe og oplev god stemning i en uformel atmosfære, opbyg nye bekendtskaber, få velsmagende morgenmad og bliv inspireret."
    }
  }), _vm._v(" "), _c('seo-google-image', {
    attrs: {
      "content": ""
    }
  })], 1), _vm._v(" "), _c('intro', {
    attrs: {
      "videoId": "7bGJbhDr7TM",
      "bg": "/static/images/focus-1.jpg",
      "buttonText": "DATO KOMMER SNART"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            VOLKSWAGEN GLADSAXE"), _c('br'), _vm._v("ERHVERVSKLUB\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "subtitle"
    },
    slot: "subtitle"
  }, [_vm._v("\n            Deltag i Volkswagen ErhvervsCenter Gladsaxes netværksmøde og udvid dit netværk på en uformel måde.\n        ")])]), _vm._v(" "), _c('boxes', {
    attrs: {
      "intro": "Volkswagen ErhvervsCenter Gladsaxes netværksmøde",
      "firstText": "God stemning & nye bekendtskaber",
      "firstPicture": "/static/images/focus-1.jpg",
      "secondText": "Minvolkswagen: Din vej til flådestyring",
      "secondPicture": "/static/images/focus-2.jpg",
      "thirdText": "Innovativ bilindretning",
      "thirdPicture": "/static/images/focus-3.jpg"
    }
  }), _vm._v(" "), _c('practical-info', {
    attrs: {
      "title": "Dette skal du glæde dig til"
    }
  }, [_c('div', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n            For at give vores kunder ny inspiration og et forum for networking, holder vi for danske håndværkere jævnligt netværksmøder. Her er der mulighed for deltagerne, vores oplægsholdere og os at indgå i tæt dialog og videndele om udfordringer, ny teknologi og de muligheder, der byder sig i fremtiden.\n            "), _c('br'), _c('br'), _vm._v("\n            Hvert møde har et fagligt fokus, hvor vi får besøg af en ekspert på området. Det kan være finansiering, forsikring, håndværktøj, revision, markedsføring og mange flere. Hold øje med, hvad du kan opleve ved det møde, du ønsker at deltage i.\n            "), _c('br'), _c('br'), _vm._v("\n            Vi starter tidligt om morgenen, så det ikke går ud over din arbejdstid. Der serveres morgenmad og en velsmagende kop friskbrygget kaffe. Vi glæder os til at se dig.\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "address"
    },
    slot: "address"
  }, [_vm._v("\n            Volkswagen Gladsaxe"), _c('br'), _vm._v("\n            Dynamovej 5"), _c('br'), _vm._v("\n            2860 Søborg\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "datetime"
    },
    slot: "datetime"
  }, [_vm._v("\n            Dato kommer snart\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "partners"
    },
    slot: "partners"
  }, [_c('a', {
    attrs: {
      "href": "https://deveo.dk/",
      "target": "_blank",
      "rel": "noopener nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/deveo-logo.png",
      "width": "120"
    }
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "href": "https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "vw-bold"
    }
  }, [_vm._v("Volkswagen")]), _vm._v(" Finans\n            ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.volkswagen.dk/da/ny-volkswagen/samlede-losninger.html",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "vw-bold"
    }
  }, [_vm._v("Volkswagen")]), _vm._v(" Forsikring\n            ")])])]), _vm._v(" "), _c('promo', {
    attrs: {
      "title": "Transporter",
      "staticCarId": "1",
      "buttonLink": "https://www.volkswagen-erhvervsbiler.dk/da/modeller/transporter-kassevogn.html#",
      "buttonText": "Online showroom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n            Transporter med sikkerheds- eller infotainmentpakke uden merpris.\n        ")])]), _vm._v(" "), _c('statement-and-price', {
    attrs: {
      "title": "Gå herfra inspireret og med nye bekendtskaber",
      "price": "GRATIS",
      "mainEmployeeImage": "/static/images/jkh.jpg",
      "mainEmployeeName": "Jens Kristian Havkrog",
      "mainEmployeeTitle": "Salgschef, Volkswagen ErhvervsCenter Gladsaxe",
      "secondaryEmployeeImage": "/static/images/df.jpg",
      "secondaryEmployeeName": "Dennis Franzeen",
      "secondaryEmployeeTitle": "Salgsrådgiver, Volkswagen ErhvervsCenter Gladsaxe"
    }
  }, [_c('div', {
    attrs: {
      "slot": "statement"
    },
    slot: "statement"
  }, [_vm._v("\n            Deltag i vores uformelle netværksmøde, hvor du både bliver inspireret af nye løsninger indenfor teknologi, leasing og meget mere, samtidig med at vi sammen kan løse de problemstillinger du måtte have i din dagligdag.\n            "), _c('br'), _c('br'), _vm._v("\n            Bilverdenen er i konstant forandring og i årene fremover vil der derfor blive stillet større krav til driftsomkostningerne/TCO af virksomhedens flåde. Du vil få større budgetsikkerhed samt højne kvaliteten af din investering.\n            "), _c('br'), _c('br'), _vm._v("\n            Om din flåde består af 1 eller 100 biler, står vi altid klar med professionel rådgivning.\n            "), _c('br'), _c('br'), _vm._v("\n            Vi glæder os til at byde dig velkommen i Volkswagen familien.\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Adgang til arrangement")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Mad & drikke")]), _vm._v(" "), _c('li', {
    staticClass: "check-mark",
    attrs: {
      "slot": "benefits"
    },
    slot: "benefits"
  }, [_vm._v("Networking")])]), _vm._v(" "), _c('registration', {
    attrs: {
      "eventId": "ddb054affa69ce60f11597144",
      "eventToken": "402a99fa66",
      "name": "Gladsaxe",
      "disabled": true
    }
  }), _vm._v(" "), _c('contact', {
    attrs: {
      "title": "Volkswagen ErhvervsCenter Gladsaxe",
      "phone": "+45 43 22 33 13",
      "facebookUrl": "VolkswagenGladsaxe"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-cover bg-overlay-black-6",
    style: ('height:' + _vm.windowHeight + 'px!important'),
    attrs: {
      "id": "register"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-5"
  }, [_c('div', {
    staticClass: "form-wrapper border-round padding-8"
  }, [(!_vm.disabled) ? _c('div', {
    attrs: {
      "id": "mc_embed_signup"
    }
  }, [(!_vm.submitted) ? _c('form', {
    staticClass: "validate",
    attrs: {
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register()
      }
    }
  }, [_c('div', {
    staticClass: "form-val-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.CNAME),
      expression: "body.CNAME"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Virksomhed"
    },
    domProps: {
      "value": (_vm.body.CNAME)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "CNAME", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-val-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.FNAME),
      expression: "body.FNAME"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Fulde navn"
    },
    domProps: {
      "value": (_vm.body.FNAME)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "FNAME", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-val-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.EMAIL),
      expression: "body.EMAIL"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "type": "email",
      "placeholder": "E-mail adresse"
    },
    domProps: {
      "value": (_vm.body.EMAIL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "EMAIL", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-val-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.PHONE),
      expression: "body.PHONE"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Telefon"
    },
    domProps: {
      "value": (_vm.body.PHONE)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "PHONE", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('button', {
    staticClass: "form-submit btn btn-base-color btn-medium button",
    attrs: {
      "type": "submit",
      "name": "subscribe",
      "id": "mc-embedded-subscribe",
      "disabled": !_vm.isValidated
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("Tilmeld")]) : _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])])]) : _c('div', {
    staticClass: "submit-success"
  }, [_c('h3', [_vm._v("\n                                Tak for din tilmelding!\n                            ")]), _vm._v(" "), _c('p', [_vm._v("\n                                Du vil modtage nærmere info via e-mail snarest.\n                            ")])])]) : _c('div', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("\n                        Dato for næste arrangement kommer snart, hvorefter du kan tilmelde dig her på siden.\n                    ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-7 xs-text-center"
  }, [_c('span', {
    staticClass: "display-block font-family-alt letter-spacing-1 opacity-9 margin-7 no-margin-bottom no-margin-rl text-white text-medium text-uppercase"
  }, [_vm._v("Tilmeld dig allerede nu!")]), _vm._v(" "), _c('h2', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-2 margin-5 no-margin-bottom no-margin-rl text-white xs-title-medium title-extra-large-3 text-uppercase vw-bold"
  }, [_vm._v("Vil du med?"), _c('br'), _vm._v("Tilmeld dig her")]), _vm._v(" "), _c('span', {
    staticClass: "bg-base-color display-inline-block margin-5-5 no-margin-rl separator-line-medium-thick-long"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsletter-wrapper"
  }, [_c('span', [_c('a', {
    attrs: {
      "rel": "noopener",
      "target": "_blank",
      "href": "https://www.volkswagen-erhvervsbiler.dk/app/web/erhverv/tilmeld-nyhedsbrev/"
    }
  }, [_vm._v("\n                                        Tilmeld dig vores nyhedsbrev →\n                                    ")])])])
}]}

/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[170]);


// WEBPACK FOOTER //
// static/js/app.a55ad11824db561e1160.js